// Bildirim.js — MESAJLAR ORTADA, HATALAR KALICI (6 Eyl 2026)
//
// 🔑 Serkan, aynı şeyi iki kez yaşadıktan sonra: *"Uyarı verdi, yine altta
//    kaçırdım."* · *"Bütün hata mesajları ortada görünsün, kenarda durup
//    hemen kaybolmasın hiçbir mesaj."*
//
// 🔴 NEDEN ÖNEMLİ — ölçüldü (6 Eyl): AdminPanel'de 39 hata mesajı var,
//    10 tanesi sunucunun REDDETTİĞİ kayıtları taşıyor, ve hiçbiri ekranda
//    kalmıyordu (3.5 sn sonra kayboluyordu, sağ altta). Yani "kaydedilmedi"
//    diyen mesaj, kaydedildi sanan kullanıcıya yetişemiyordu. Kaybolan bir
//    hata mesajı, pratikte hiç konuşmamakla aynıdır (İlke 2).
//
// 🔴 İKİ AYRI TOAST VARDI (AdminPanel + SuperAdminPanel) — aynı işin iki
//    sahibi, kaçınılmaz ayrışma (İlke 3). İkisi de buraya bağlandı.
//
// DAVRANIŞ:
//   · hata   → ORTADA, KALICI. Kendiliğinden kapanmaz; kapatılana kadar durur.
//   · başarı → ORTADA, kısa (2.5 sn). "Saved." için tıklatmak eziyet olurdu.
//
// 🔑 DETAY + ⓘ (29 Eyl 2026). Serkan: *"hata mesajı verdiğinde hatanın nedeni
//    üstüne gelip i remarka tıklayınca çıkacak mı? nasıl anlayacak kullanıcı?"*
//    → seçenek B: kartta kısa cümle, NEDEN · NE YAPMALI · TEKNİK ⓘ'ye basınca.
// 🔴 BAŞLIK YALAN SÖYLÜYORDU: her hata "Could not save — nothing was written"
//    başlığıyla çıkıyordu; "SCL için kaydedildi, AAK için kaydedilmedi" diyen
//    kısmi mesajlarda da. `detay.baslik` verilirse o yazılır (PARTLY SAVED ·
//    NOT SAVED); verilmezse eski başlık kalır — yalnız düz metin gönderen
//    çağrılar için doğru olan odur (doğrulama hataları, hiç yazılmamış kayıt).
//   detay = { baslik?, aciklama?: { neden, neYapmali, teknik? },
//             satirlar?: [{ kim?, metin, aciklama: { kunye?, madde?:{kunye,metin}, neYapmali } }] }
// 🔑 SATIRLAR (29 Eyl 2026 · kural ihlali kartı): her gerekçe AYRI satır, her
//    satırın KENDİ ⓘ'si — içinde maddenin kendi metni (künyeden, uydurulmaz)
//    ve ne yapılabileceği. Künyesi olmayan gerekçe (ör. çakışma) madde göstermez.
import React, { useEffect, useState } from 'react';
import { dbHata } from './dbHata';
import { usePencereKapat, KapatX } from './pencereKapat';

const C = {
  bg2:'var(--bg2)', bg3:'var(--bg3)', border2:'var(--border2)',
  red:'var(--red)', green:'var(--green)', t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)',
};

const S = {
  ortala:{ position:'fixed', inset:0, display:'flex', alignItems:'center',
           justifyContent:'center', zIndex:400, pointerEvents:'none' },
  perde:{ position:'fixed', inset:0, background:'rgba(0,0,0,.45)', zIndex:399 },
  kart:{ pointerEvents:'auto', background:C.bg2, border:`1px solid ${C.red}`,
         borderRadius:10, padding:'18px 22px', maxWidth:560, minWidth:340,
         boxShadow:'0 18px 50px rgba(0,0,0,.55)' },
  baslik:{ fontSize:11, fontWeight:700, letterSpacing:1.5, color:C.red,
           fontFamily:'var(--mono)', textTransform:'uppercase', marginBottom:8 },
  metin:{ fontSize:13, color:C.t1, lineHeight:1.65 },
  ham:{ marginTop:10, padding:'7px 10px', background:C.bg3, borderRadius:5,
        fontSize:10.5, color:C.t3, fontFamily:'var(--mono)', lineHeight:1.5,
        wordBreak:'break-word' },
  dugme:{ marginTop:14, background:'none', border:`1px solid ${C.border2}`, color:C.t2,
          padding:'7px 18px', fontSize:10.5, letterSpacing:1.2, fontFamily:'var(--mono)',
          borderRadius:5, cursor:'pointer', float:'right' },
  // ⓘ — InfoDot'un noktasıyla aynı görünüm (tek dil: "i = açıklama").
  nokta:{ marginLeft:8, cursor:'pointer', fontSize:11, fontWeight:700, color:'var(--accent)',
          border:'1px solid var(--accent)', borderRadius:'50%', width:17, height:17,
          display:'inline-flex', alignItems:'center', justifyContent:'center', lineHeight:1,
          fontFamily:'var(--mono)', background:'none', padding:0, verticalAlign:'middle' },
  ipucu:{ marginTop:8, fontSize:10.5, color:C.t3, fontFamily:'var(--mono)', letterSpacing:.5 },
  acik:{ marginTop:12, padding:'10px 12px', background:C.bg3, borderLeft:'2px solid var(--accent)',
         borderRadius:4 },
  acikEtiket:{ fontSize:10, color:C.t3, fontFamily:'var(--mono)', letterSpacing:1.2,
               textTransform:'uppercase', marginTop:8, marginBottom:3 },
  acikMetin:{ fontSize:12.5, color:C.t2, lineHeight:1.65 },
  basari:{ pointerEvents:'auto', background:C.bg2, border:`1px solid ${C.green}`,
           borderRadius:8, padding:'11px 20px', fontSize:12.5, color:C.t1,
           fontFamily:'var(--mono)', boxShadow:'0 12px 34px rgba(0,0,0,.45)' },
};

export default function Bildirim({ msg, type, onClose, detay = null }) {
  const hataMi = type === 'error';
  // ⓘ açıklaması varsayılan KAPALI; yeni mesaj gelince yeniden kapanır.
  const [acik, setAcik] = useState(false);
  const [acikSatir, setAcikSatir] = useState(null);
  useEffect(() => { setAcik(false); setAcikSatir(null); }, [msg]);

  // Başarı mesajı kendiliğinden kapanır; HATA ASLA. Kapanma süresi burada
  // TEK YERDE durur — çağrı yerleri süre bilmez.
  useEffect(() => {
    if (!msg || hataMi) return undefined;
    const t = setTimeout(onClose, 2500);
    return () => clearTimeout(t);
  }, [msg, hataMi, onClose]);

  // Esc kapatır — kalıcı olmak "kapatılamaz" demek değildir. 12 Eki 2026: ortak yığından (pencereKapat.js) ve
  // YALNIZ HATA KARTI için: kart açık penceresinin ÜSTÜNDE durur, ESC önce onu kapatır, alttaki pencere açık kalır.
  // (Eskiden window dinleyicisiydi — tek ESC kartı da arkasındaki çekmeceyi de kapatıyordu.) Başarı mesajı pencere
  // değildir, 2,5 sn'de kendisi kapanır; yığına girseydi o sürede bir pencereye basılan ESC'yi yutardı.
  usePencereKapat(onClose, !!msg && hataMi);

  if (!msg) return null;

  if (!hataMi) {
    return (
      <div style={S.ortala}>
        <div style={S.basari} data-testid="bildirim-ok">OK &nbsp;{msg}</div>
      </div>
    );
  }

  // Sunucu metni okunur cümleye çevrilir; TANINMAYAN hata yorumlanmaz.
  const { metin, taninan, ham } = dbHata(msg);
  const aciklama = detay?.aciklama || null;
  const satirlar = detay?.satirlar || [];
  return (
    <>
      <div style={S.perde} onClick={onClose} />
      <div style={S.ortala}>
        <div style={S.kart} data-testid="bildirim-hata" role="alert">
          <div style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
            <div style={{ ...S.baslik, flex:1, minWidth:0 }} data-testid="bildirim-baslik">
              {detay?.baslik || 'Could not save — nothing was written'}
              {aciklama && (
                <button style={S.nokta} data-testid="bildirim-i" aria-expanded={acik}
                        aria-label="Why, and what to do" onClick={() => setAcik(a => !a)}>i</button>
              )}
            </div>
            <KapatX onClose={onClose} testid="bildirim-x" />
          </div>
          <div style={S.metin} data-testid="bildirim-metin">{metin}</div>
          {/* Çevirdiysek ham metni de gösteririz: teşhis kaybolmasın. */}
          {taninan && ham !== metin && (
            <div style={S.ham} data-testid="bildirim-ham">{ham}</div>
          )}
          {satirlar.length > 0 && (
            <div data-testid="bildirim-satirlar" style={{ marginTop:10 }}>
              {satirlar.map((st, i) => (
                <div key={i} style={{ padding:'6px 0', borderTop:`1px solid ${C.border2}` }}>
                  <div style={{ fontSize:12, color:C.t1, lineHeight:1.6, fontFamily:'var(--mono)' }}>
                    {st.kim && <b style={{ marginRight:6 }}>{st.kim}</b>}
                    <span data-testid={`bildirim-satir-${i}`}>{st.metin}</span>
                    {st.aciklama && (
                      <button style={S.nokta} data-testid={`bildirim-satir-i-${i}`} aria-expanded={acikSatir === i}
                              aria-label="The rule, and what to do"
                              onClick={() => setAcikSatir(a => (a === i ? null : i))}>i</button>
                    )}
                  </div>
                  {acikSatir === i && st.aciklama && (
                    <div style={S.acik} data-testid={`bildirim-satir-aciklama-${i}`}>
                      <div style={{ ...S.acikEtiket, marginTop:0 }}>
                        {st.aciklama.madde ? st.aciklama.madde.kunye
                          : st.aciklama.kunye ? `${st.aciklama.kunye} — article text not found; read the regulation directly`
                          : 'Not a rule of the regulation — a fact about the records'}
                      </div>
                      {st.aciklama.madde && (
                        <div style={{ ...S.acikMetin, maxHeight:220, overflowY:'auto', whiteSpace:'pre-wrap',
                                      fontSize:11.5 }}>{st.aciklama.madde.metin}</div>
                      )}
                      <div style={S.acikEtiket}>What to do</div>
                      <div style={S.acikMetin}>{st.aciklama.neYapmali}</div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          {aciklama && !acik && (
            <div style={S.ipucu}>ⓘ — why this happened, and what to do</div>
          )}
          {!aciklama && satirlar.some(st => st.aciklama) && (
            <div style={S.ipucu}>ⓘ next to a line — the rule itself, and what to do</div>
          )}
          {aciklama && acik && (
            <div style={S.acik} data-testid="bildirim-aciklama">
              <div style={{ ...S.acikEtiket, marginTop:0 }}>Why</div>
              <div style={S.acikMetin}>{aciklama.neden}</div>
              <div style={S.acikEtiket}>What to do</div>
              <div style={S.acikMetin}>{aciklama.neYapmali}</div>
              {aciklama.teknik && (<>
                <div style={S.acikEtiket}>Technical</div>
                <div style={{ ...S.acikMetin, fontFamily:'var(--mono)', fontSize:11, color:C.t3,
                              wordBreak:'break-word' }}>{aciklama.teknik}</div>
              </>)}
            </div>
          )}
          <div style={{ overflow:'hidden' }}>
            <button style={S.dugme} onClick={onClose} data-testid="bildirim-kapat">DISMISS</button>
          </div>
        </div>
      </div>
    </>
  );
}
